import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class BeStudyCostingService {

  constructor(private http: HttpClient) { }

  
  getRegCostingDetails() {
    return this.http.get('assets/mockdata/BE_STUDY_COSTING.json')  }
}
